import { render } from "./other-products.vue?vue&type=template&id=3de4361d&scoped=true"
import script from "./other-products.vue?vue&type=script&lang=js"
export * from "./other-products.vue?vue&type=script&lang=js"

import "./other-products.vue?vue&type=style&index=0&id=3de4361d&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_1rhhjrwiu7uq22_9030/msg/file/2026-08/ubang-copilot-agents-web-deploy-2026-08-31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de4361d"]])

export default __exports__